import React from "react";
import ReactDOM from "react-dom";
import styles from "../../styles/crearEmpresaPopup.module.css";
import { useTranslation } from "react-i18next";

const ReiniciarEncuestaPopup = ({ onClose, onReset, userName }) => {
  const { t } = useTranslation();
  const handleReset = () => {
    onReset();
    onClose();
  };

  const handleClickOutside = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return ReactDOM.createPortal(
    <div className={styles.popupOverlay} onClick={handleClickOutside}>
      <div className={styles.popupContent}>
        <h2>{t("resetSurvey")}</h2>
        <p>{t("resetSurveyConfirmation")} <strong>{userName}</strong>?</p>
        <p className={styles.pconfirm}>{t("resetSurveyWarning")}</p>
        <div className={styles.popupActions}>
          <button onClick={onClose} className={styles.buttonCancel}>{t("cancel")}</button>
          <button onClick={handleReset} className={styles.buttonDelete}>{t("reset")}</button>
        </div>
      </div>
    </div>,
    document.body
  );
};

export default ReiniciarEncuestaPopup;
